/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { Component } from 'react';
import { staticContentsImagePath as BASE_IMAGE_PATH, OPERATOR_ID} from '../../configs/const';
import { DOMAINDISPLAY, ABOUTUSNUMBER } from '../../configs/apkFileName';
let oid = OPERATOR_ID.toLowerCase()


export default class ContactUs extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }
    
    render() {
        return (
            <>
              <section className='sportbook-livecasino'>                
                <div className="subpage-head1">
                    <div className="subpage-head1__image">
                        <img alt="Offers Banner" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/offers-banner.jpg"} />
                    </div> 
                    <div className="subpage-head1__content">
                        <h1 className="subpage-head1__title">Contact Us</h1>
                    </div>
                </div>
            </section>
            <section className="about mt-5">
                <div className="container">
                    <div className="row">
                       <div className='col-12'>
                           {/* <p className='section-head__title text-center text-uppercase'>About Us</p> */}
                        </div>
                        <div className='col-12'>
                            <p className='main-text fbold mb-3'>Financial Subjects and Collaboration:&nbsp;<span className='contactlink'>finance@1xbook.com</span></p>
                            <p className='main-text fbold mb-3'>Public Relations and Advertising:&nbsp;<span className='contactlink'>marketing@1xbook.com</span></p>
                            <p className='main-text fbold mb-3'>Customer Service:&nbsp;<span className='contactlink'>support@1xbook.com</span></p>
                            <p className='main-text fbold mb-3'>Advise Us:&nbsp;<span className='contactlink'>feedback@1xbook.com</span></p>
                            <p className='main-text fbold mb-3'>Affiliate:&nbsp;<span className='contactlink'>affiliate@1xbook.com</span></p>
                           
                        </div>
                    </div>                   
                </div>
            </section>
            </>
        )
    }
}
